module.exports = "/assets/98214b6e393f8bf84f5ebe1f10c7f0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AF.png
// module id = 2322
// module chunks = 0